const israelHourFormatter = new Intl.DateTimeFormat("he-IL", {
  hour: "2-digit",
  hour12: false,
  timeZone: "Asia/Jerusalem",
});

export function getIsraelGreeting(now = new Date()) {
  const hour = Number(israelHourFormatter.formatToParts(now).find((part) => part.type === "hour")?.value ?? 0) % 24;

  if (hour < 12) return "בוקר טוב";
  if (hour < 17) return "צהריים טובים";
  return "ערב טוב";
}
